<template>
  <div class="bg-white rounded-2xl shadow-xl border border-gray-100 py-5 px-6 flex flex-col justify-between">
    <p class="text-xs font-semibold uppercase tracking-widest text-gray-400">
      {{ t("rank_label") }}
    </p>
    <div>
      <div class="flex items-baseline gap-1.5">
        <span class="text-4xl font-extrabold tracking-tight">#{{ currentRank }}</span>
        <span class="text-base text-gray-500">/ {{ totalStores }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    currentRank: {
      type: Number,
      required: true,
    },
    totalStores: {
      type: Number,
      required: true,
    },
  },
};
</script>

<i18n src="./TieredChallengeStoreRank.i18n.json"></i18n>
